import React from 'react'

const LoaderIcon = () => (
  <div className="LoaderWrapper">
    <svg
      className="LoaderIcon-svg"
      width="120px"
      height="120px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="105.0" cy="60.0" r="8" fill="#009fe3" fill-opacity="0.30" />
      <circle cx="91.82" cy="91.82" r="8" fill="#009fe3" fill-opacity="0.40" />
      <circle cx="60.0" cy="105.0" r="8" fill="#009fe3" fill-opacity="0.50" />
      <circle cx="28.18" cy="91.82" r="8" fill="#009fe3" fill-opacity="0.60" />
      <circle cx="15.0" cy="60.0" r="8" fill="#009fe3" fill-opacity="0.70" />
      <circle cx="28.18" cy="28.18" r="8" fill="#009fe3" fill-opacity="0.80" />
      <circle cx="60.0" cy="15.0" r="8" fill="#009fe3" fill-opacity="0.90" />
    </svg>
  </div>
)

export default LoaderIcon
